import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Scale, Mail, ArrowLeft } from "lucide-react";
import BackToTop from "../../components/BackToTop/BackToTop";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import HeroBg from "../../../src/images/hero-bg.png";

const Terms = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-gradient-to-b from-gray-50 to-white">
            <BackToTop />

            {/* ================= HEADER ================= */}
            <Header />

            <div className="relative">

                <div className="absolute inset-0 w-full h-full">
                    <img
                        src={HeroBg}
                        loading="lazy"
                        sizes="(max-width: 1440px) 100vw, 1440px"
                        alt="hero"
                        className="w-full h-full object-cover"
                    />
                </div>

                {/* <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-0 -left-40 w-[400px] h-[400px] bg-gradient-to-r from-indigo-200/20 via-purple-200/20 to-pink-200/20 rounded-full blur-3xl animate-float-slow"></div>
                    <div className="absolute bottom-0 -right-40 w-[400px] h-[400px] bg-gradient-to-l from-pink-200/20 via-purple-200/20 to-indigo-200/20 rounded-full blur-3xl animate-float-slower"></div>

                    {[...Array(50)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-1 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full animate-float-particle"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 8}s`,
                                animationDuration: `${15 + Math.random() * 15}s`,
                                opacity: 0.2,
                            }}
                        />
                    ))}
                </div> */}

                {/* Main Content */}
                <div className="max-w-6xl mx-auto px-6 py-20 relative">
                    {/* Hero Section */}
                    <div className="text-center mb-12 mt-12">
                        <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-6">
                            <Scale className="h-4 w-4 text-indigo-600" />
                            <span className="text-sm font-medium text-indigo-600">Legal</span>
                        </div>
                        <h1 className="text-4xl md:text-5xl font-bold mb-4">
                            Terms &{" "}
                            <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                                Conditions
                            </span>
                        </h1>
                        {/* <p className="text-gray-500 text-lg">Last updated: March 10, 2026</p> */}
                    </div>

                    {/* Quick Navigation */}
                    {/* <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-gray-100">
                    <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
                        <FileText className="h-5 w-5 text-indigo-600" />
                        Quick Navigation
                    </h2>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                        {[
                            "Acceptance of Terms",
                            "User Accounts",
                            "Content Guidelines",
                            "Intellectual Property",
                            "Subscription Terms",
                            "Limitation of Liability",
                            "Termination",
                            "Governing Law",
                            "Contact Us"
                        ].map((item, i) => (
                            <a
                                key={i}
                                href={`#section-${i + 1}`}
                                className="text-sm text-gray-600 hover:text-indigo-600 hover:underline transition-colors"
                            >
                                {item}
                            </a>
                        ))}
                    </div>
                </div> */}

                    {/* Terms Content */}
                    <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100 space-y-8">

                        {/* Section 1 */}
                        <section id="section-1" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">1</span>
                                Acceptance of Terms
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    Welcome to SocialTV ("Company," "we," "our," "us"). By accessing or using our website, mobile application,
                                    and services (collectively, the "Services"), you agree to be bound by these Terms and Conditions ("Terms").
                                </p>
                                <p>
                                    If you are using the Services on behalf of an organization, you represent and warrant that you have the
                                    authority to bind that organization to these Terms. If you do not agree to these Terms, you may not access
                                    or use the Services.
                                </p>
                            </div>
                        </section>

                        {/* Section 2 */}
                        <section id="section-2" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">2</span>
                                User Accounts
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    To access certain features of our Services, you must register for an account. You agree to provide accurate,
                                    current, and complete information during the registration process and to update such information to keep it
                                    accurate, current, and complete.
                                </p>
                                <p className="font-medium text-gray-900">You are responsible for:</p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>Maintaining the confidentiality of your account credentials</li>
                                    <li>All activities that occur under your account</li>
                                    <li>Notifying us immediately of any unauthorized use of your account</li>
                                    <li>Ensuring that your use of the Services complies with all applicable laws</li>
                                </ul>
                            </div>
                        </section>

                        {/* Section 3 */}
                        <section id="section-3" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">3</span>
                                Content Guidelines
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    Our Services allow you to upload, submit, store, send, or receive content. You retain all ownership rights
                                    to your content. However, by uploading content, you grant us a worldwide, non-exclusive, royalty-free license
                                    to use, reproduce, modify, and display your content solely for the purpose of providing the Services.
                                </p>
                                <p className="font-medium text-gray-900">You agree not to upload content that:</p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>Infringes on any third party's intellectual property rights</li>
                                    <li>Contains illegal, harmful, or offensive material</li>
                                    <li>Violates any applicable laws or regulations</li>
                                    <li>Contains malware, viruses, or malicious code</li>
                                    <li>Is false, misleading, or deceptive</li>
                                </ul>
                            </div>
                        </section>

                        {/* Section 4 */}
                        <section id="section-4" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">4</span>
                                Intellectual Property
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    The Services, including their "look and feel," proprietary content, features, and functionality, are owned
                                    by SocialTV and are protected by international copyright, trademark, patent, trade secret, and other
                                    intellectual property laws.
                                </p>
                                <p>
                                    Our name and logo are trademarks of SocialTV. You may not use these trademarks without our prior written
                                    permission. All other trademarks, service marks, and logos used on our Services are the property of their
                                    respective owners.
                                </p>
                            </div>
                        </section>

                        {/* Section 5 */}
                        <section id="section-5" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">5</span>
                                Subscription Terms
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    Some features of our Services require a paid subscription. We offer various subscription plans with different
                                    features and price points. By subscribing, you agree to pay the applicable fees.
                                </p>
                                <div className="bg-gray-50 p-4 rounded-xl">
                                    <p className="font-medium text-gray-900 mb-2">Key subscription terms:</p>
                                    <ul className="list-disc pl-5 space-y-1">
                                        <li>Billing occurs on a monthly or annual basis depending on your plan</li>
                                        <li>Subscriptions automatically renew unless canceled</li>
                                        <li>You can cancel anytime from your account settings</li>
                                        <li>No refunds for partial billing periods</li>
                                        <li>Prices are subject to change with 30 days notice</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        {/* Section 6 */}
                        <section id="section-6" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">6</span>
                                Limitation of Liability
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    To the maximum extent permitted by law, in no event shall SocialTV, its affiliates, officers, employees,
                                    agents, partners, or licensors be liable for any indirect, incidental, special, consequential, or punitive
                                    damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses,
                                    resulting from:
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>Your access to or use of or inability to access or use the Services</li>
                                    <li>Any conduct or content of any third party on the Services</li>
                                    <li>Any content obtained from the Services</li>
                                    <li>Unauthorized access, use, or alteration of your transmissions or content</li>
                                </ul>
                            </div>
                        </section>

                        {/* Section 7 */}
                        <section id="section-7" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">7</span>
                                Termination
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    We may terminate or suspend your account and bar access to the Services immediately, without prior notice
                                    or liability, under our sole discretion, for any reason whatsoever, including without limitation if you
                                    breach the Terms.
                                </p>
                                <p>
                                    Upon termination, your right to use the Services will immediately cease. If you wish to terminate your
                                    account, you may simply discontinue using the Services or contact us to request account deletion.
                                </p>
                            </div>
                        </section>

                        {/* Section 8 */}
                        <section id="section-8" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">8</span>
                                Governing Law
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    These Terms shall be governed and construed in accordance with the laws of the State of Delaware, United States,
                                    without regard to its conflict of law provisions.
                                </p>
                                <p>
                                    Any legal actions or proceedings relating to your access to or use of the Services shall be instituted in a
                                    state or federal court in Delaware. You and SocialTV agree to submit to the jurisdiction of, and agree that
                                    venue is proper in, these courts.
                                </p>
                            </div>
                        </section>

                        {/* Section 9 */}
                        <section id="section-9" className="scroll-mt-24">
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">9</span>
                                Changes to Terms
                            </h2>
                            <div className="pl-11 space-y-4 text-gray-600 leading-relaxed">
                                <p>
                                    We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is
                                    material, we will try to provide at least 30 days' notice prior to any new terms taking effect.
                                </p>
                                <p>
                                    By continuing to access or use our Services after those revisions become effective, you agree to be bound by
                                    the revised terms. If you do not agree to the new terms, please stop using the Services.
                                </p>
                            </div>
                        </section>

                        {/* Contact Section */}
                        <section className="border-t border-gray-200 pt-8 mt-8">
                            <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-8">
                                <div className="flex items-start gap-4">
                                    <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center flex-shrink-0">
                                        <Mail className="h-6 w-6 text-indigo-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold mb-2">Have Questions About Our Terms?</h3>
                                        <p className="text-gray-600 mb-4">
                                            Our legal team is here to help. Reach out to us with any questions about our terms and conditions.
                                        </p>
                                        <div className="flex flex-wrap gap-4">
                                            <Link
                                                to="/contact"
                                                className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-sm hover:shadow-md transition-all text-gray-700 hover:text-indigo-600"
                                            >
                                                Contact Support
                                                <ArrowLeft className="h-4 w-4 rotate-180" />
                                            </Link>
                                            <a
                                                href="mailto:publisher@jambojar.com"
                                                className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-700"
                                            >
                                                <Mail className="h-4 w-4" />
                                                publisher@jambojar.com
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            {/* ================= FOOTER ================= */}
            <Footer />
        </div>
    );
};

export default Terms;